const BASE_URL = process.env.NODE_ENV === 'production' ? 
  'https://steamsale-backend-e0d07cd1dd09.herokuapp.com'
    : 
  'http://localhost:7500'

// const BASE_URL = 'https://steamsale-backend-e0d07cd1dd09.herokuapp.com'

export default BASE_URL;